<div class="form-field-wrapper">
  @if(!viewMode){
  <label class="form-field-label" [ngClass]="{ 'required': isRequired }">
    <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
    {{ label }}
  </label>
  <ng-container *ngTemplateOutlet="enabledSelect"></ng-container>
  } @else {
  <div class="d-flex mb-2 responsive-field" [ngClass]="{ 'label-top-position': isLabelTopPosition }">
    <label class="form-field-label form-field-label__overview"
      [ngClass]="{ 'required': isRequired, 'text-secondary' : formControl.status === 'DISABLED' }">
      <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
      {{ label }}
    </label>
    @if(!inlineEditMode) {
    <div class="field-value field-value-inline select-form-field-inline select-form-field-inline__text"
      (click)="formControl.status !== 'DISABLED' ? inlineEditMode = true : false"
      [ngClass]="{'text-secondary select-form-field-inline__disabled' : formControl.status === 'DISABLED' }"
      attr.title="{{ formControl.status !== 'DISABLED' ? ('label.click_to_edit' | translate) : null }}">
      <ng-container *ngTemplateOutlet="disabledSelect"></ng-container>
    </div>
    } @else {
    <div class="w-100 select-form-field-inline">
      <ng-container *ngTemplateOutlet="enabledSelect"></ng-container>
      @if (errorText) {
      <span class="form-field-info form-field-info-inline required-label"> {{ errorText | translate }}</span>
      }
    </div>
    }
  </div>
  }

  @if (errorText && !viewMode) {
  <span class="form-field-info required-label"> {{ errorText | translate }}</span>
  }

  @if (infoText && !errorText && !viewMode) {
  <span class="form-field-info">{{ infoText }}</span>
  }

</div>

<ng-template #enabledSelect>
  <ng-select [class]="'select-form-field ' + customClass" [items]="items" [bindLabel]="bindLabel"
    [bindValue]="bindValue" [clearable]="clearable" [searchable]="searchable" [formControl]="formControl"
    [placeholder]="placeholder | translate" [ngClass]="{ 'select-required': errorText }" [multiple]="multipleSelect"
    [searchFn]="externalSearch ? returnTrue : null" (search)="onSearch($event)" (change)="change($event)"
    (clear)="onClear()" (open)="onOpen()" (scrollToEnd)="onScrollToEnd()"
    [title]="(multipleSelect ? 'label.click_to_select' : '') | translate">
    @if(multipleSelect) {
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      @if(users) {
      <div class="custom-users-pill">
        <img [src]="item.url ? item.url : '../../../../assets/img/person.png'" class="user-avatar">
        <span class="name">{{ item[bindLabel] }}</span>
        <i *ngIf="!formControl.disabled" (click)="clear(item)" class="bi bi-x-lg place-right"></i>
        @if(item.email) {
        <div class="user-email">[{{item.email}}]</div>
        }
      </div>
      }
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      {{item.fullName}} @if(item.email) {
      <div class="user-email">[{{item.email}}]</div>
      }
    </ng-template>
    } @else {
    @if(users) {
    <ng-template ng-label-tmp let-item="item">
      {{item.fullName}} @if(item.email) {
      <div class="user-email">[{{item.email}}]</div>
      }
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      {{item.fullName}} @if(item.email) {
      <div class="user-email">[{{item.email}}]</div>
      }
    </ng-template>

    }
    }
  </ng-select>
</ng-template>

<ng-template #disabledSelect>
  <ng-select [class]="'select-form-field ' + customClass" [items]="items" [bindLabel]="bindLabel"
    [bindValue]="bindValue" [clearable]="false" [searchable]="false" [formControl]="formControl"
    [placeholder]="'&nbsp;/'" (search)="onSearch($event)">
    @if(users) {
    <ng-template ng-label-tmp let-item="item">
      {{item.fullName}} @if(item.email) {
     <div class="user-email">[{{item.email}}]</div>
      }
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      {{item.fullName}} @if(item.email) {
      <div class="user-email">[{{item.email}}]</div>
      }
    </ng-template>

    }
  </ng-select>
</ng-template>

<ng-template #tipContent let-value="value">
  {{ value }}
</ng-template>